export const REORDER_STAGES = ['waiting', 'move', 'buy', 'receive', 'make'] as const;
